export const setCharacter = (character) =>{
    return{
        type : 'SETCHARACTER',
        payload : character
    }
}

export const setMovie = (movie) =>{
    return{
        type : 'SETMOVIE',
        payload : movie
    }
}

export const selectedMovie = (selectedmovie) =>{
    return{
        type : 'SELECTEDMOVIE',
        payload : selectedmovie
    }
}

export const emptySelectedMovie = () =>{
    return{
        type : 'EMPTYSELECTEDMOVIE'
    }
}

export const setStatus = (status) =>{
    return{
        type : 'SETMOVIE',
        payload : status
    }
}
